import Parse from "/server/parse-server.js";
import Radar from 'radar-sdk-js';
import { goToNextPage } from "/reusable/navigation.js";
import { formatPhone } from "/reusable/string.js";
import { storeMenuData, removeUnavailableItems } from "/toast/toast-menu.js";

"use strict";
window.Webflow ||= [];
window.Webflow.push(async () => { 

    // MARK: - ELEMENTS
    const progressModal = document.getElementById('progressModal');
    const storeNearLabel = document.getElementById("locationsNearZipLabel");
    const locationTableSection = document.getElementById("locationTableSection");

    const editZipcodeButton = document.getElementById("editZipcodeButton");
    
    const zipcodeModal = document.getElementById("zipcodeModal");
    const modalZipcodeField = document.getElementById("modalZipcodeField");
    const modalZipcodeButton = document.getElementById("modalZipcodeButton");

    var locations = [];

    function setUpView() {
        const pickupAddress = JSON.parse(sessionStorage.getItem('pickupAddress'));
        if (pickupAddress != null) {
            storeNearLabel.innerText = 'STORES NEAR: ' + pickupAddress.postalCode;
            modalZipcodeField.value = pickupAddress.postalCode;
            loadLocations();
        } else {
            zipcodeModal.style.display = 'flex';
        }
    }

    editZipcodeButton.addEventListener('click', async () => {
        zipcodeModal.style.display = 'flex';
    });

    // MARK: - LOAD DATA
    async function loadLocations() {
        const pickupAddress = JSON.parse(sessionStorage.getItem('pickupAddress'));
        const geoPoint = new Parse.GeoPoint({latitude: pickupAddress.latitude, longitude: pickupAddress.longitude});
        progressModal.style.display = 'flex';
        try {
            locations = await Parse.Cloud.run('loadLocations', {'geoPoint': geoPoint});
            locationTableSection.style.display = 'block';
            setUpLocationsTable();
        } catch(e) {
            alert(e.message);
        }
        progressModal.style.display = 'none';
    }

    // MARK: - TABLE FUNCTIONS
    async function setUpLocationsTable() {

        const locationCell = document.querySelector('[locations="cell"]');
        const locationParent = locationCell.parentNode;
        const locationCells = [...document.querySelectorAll('[locations="cell"]')];
        clearCellItems(locationCells);

        for (let i = 0; i < locations.length; i++) {

            const newLocationCell = i === 0 ? locationCells[0] : locationCells[0].cloneNode(true);

            const location = locations[i];

            const distanceLabel = newLocationCell.querySelector('[locations="distanceLabel"]');
            const pickupAddress = JSON.parse(sessionStorage.getItem('pickupAddress'));
            const userPoint = new Parse.GeoPoint({latitude: pickupAddress.latitude, longitude: pickupAddress.longitude});
            const locationPoint = locations[i].get('location');
            const distance = userPoint.milesTo(locationPoint);
            const distanceSt = distance.toFixed(1) + " miles away";
            distanceLabel.innerText = distanceSt;

            const cityLabel = newLocationCell.querySelector('[locations="cityLabel"]');
            cityLabel.innerText = locations[i].get('city').toUpperCase();

            const addressLabel = newLocationCell.querySelector('[locations="addressLabel"]');
            const address = locations[i].get('address').toUpperCase();
            const state = locations[i].get('state').toUpperCase();
            const zipcode = locations[i].get('zipcode').toUpperCase();
            addressLabel.innerText = address + ', ' + state + ' ' + zipcode;

            var openRows = [];
            const moreInfoButton = newLocationCell.querySelector('[locations="moreInfoButton"]');
            const bottomCell = newLocationCell.querySelector('[locations="bottomCell"]');
            moreInfoButton.addEventListener('click', () => {
                if (openRows.includes(i)) {
                    bottomCell.style.display = 'none';
                    let index = openRows.indexOf(i);
                    openRows.splice(index, 1);
                    moreInfoButton.textContent = 'MORE INFO'
                } else {
                    bottomCell.style.display = 'flex';
                    openRows.push(i);
                    moreInfoButton.textContent = 'LESS INFO'
                }
            });

            const chooseButton = newLocationCell.querySelector('[locations="pickupHereButton"]');
            chooseButton.addEventListener('click', async () => {
                const location = locations[i];
                const locationObject = {
                    id: location.id,
                    city: location.get('city'),
                    address: location.get('address'),
                    state: location.get('state'),
                    zipcode: '' + location.get('zipcode'),
                    phone: location.get('phonenumber')
                }
                localStorage.setItem('location', JSON.stringify(locationObject));
                sessionStorage.setItem('deliveryBool', 'false');

                progressModal.style.display = 'flex';
                const currentUser = Parse.User.current();
                if (currentUser != null) {
                    await Parse.Cloud.run('setUserLocation', {'locationid': location.id});
                    await currentUser.fetch();
                }

                const restaurantGuid = location.get('guid');
                const toastLocation = await Parse.Cloud.run('getToastLocation', {'restaurantGuid': restaurantGuid});
                localStorage.setItem('toastLocation', JSON.stringify(toastLocation.get('object')));
                
                const toastOrderSchedule = await Parse.Cloud.run('getToastOrderSchedule', {'restaurantGuid': restaurantGuid});
                localStorage.setItem('toastOrderSchedule', JSON.stringify(toastOrderSchedule.get('object')));

                const parseMenu = await Parse.Cloud.run('loadToastMenu', {'restaurantGuid': restaurantGuid});
                const toastMenuObject = parseMenu.get('object');
                storeMenuData(toastMenuObject);

                const stock = await Parse.Cloud.run('loadToastStock', {'restaurantGuid': restaurantGuid});
                const stocks = stock.get('objects');
                const removeIndexes = removeUnavailableItems(stocks);
                if (removeIndexes != null) {
                    if (removeIndexes.length > 0) {
                        removeIndexes.sort(function(a, b) { return b - a; });
                        await Parse.Cloud.run('removeToastSelections', {'indexes': removeIndexes, 'locationid': location.id});                    
                        alert("Unavailable items have been removed from your box"); 
                    }
                }
                
                progressModal.style.display = 'none';
                goToNextPage('/menu');
            });

            //const image = newLocationCell.querySelector('[locations="image"]');
            //image.src = locations[i].image;

            const phoneButton = newLocationCell.querySelector('[locations="phoneButton"]');
            const phone = locations[i].get('phonenumber');
            phoneButton.innerText = formatPhone(phone);
            phoneButton.addEventListener('click', () => {
                document.location.href="tel:"+phone;
            });

            const directionsButton = newLocationCell.querySelector('[locations="directionsButton"]');
            directionsButton.addEventListener('click', () => {
                const address = location.get('address');
                const city = location.get('city');
                const state = location.get('state');
                const zipcode = location.get('zipcode');
                const finalAddress = address + ' ' + city + ' ' + state + ' ' + zipcode;
                const addressLink = finalAddress.replaceAll(' ','+');
                const addressUrl = 'https://maps.google.com/?q=' + "Lupo+Pizzeria+" + addressLink;
                window.open(addressUrl, "_blank");
            });

            const locationPageButton = newLocationCell.querySelector('[locations="locationPageButton"]');
            locationPageButton.addEventListener('click', () => {
                const city = location.get('city').toLowerCase();
                if (city.includes('fair haven')) {
                    goToNextPage('/fair-haven');
                } else if (city.includes('west long branch')) {
                    goToNextPage('/west-long-branch');
                }
            });

            const hoursLabel = newLocationCell.querySelector('[locations="hoursLabel"]');
            // Set hours label
            const restaurantGuid = location.get('guid');
            const toastOrderSchedule = await Parse.Cloud.run('getToastOrderSchedule', {'restaurantGuid': restaurantGuid});
            const orderSchedule = toastOrderSchedule.get('object');
            if (orderSchedule != null) {
                const servicePeriods = orderSchedule.servicePeriods;

                const servicePeriod = servicePeriods.find(obj => obj.diningOptionBehavior === 'TAKE_OUT');
                if (servicePeriod != null) {

                    const dayPeriods = servicePeriod.dayPeriods;

                    var timeStrings = [];
                    const daysOfWeek = ["SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"];
                    for (const dayOfWeek of daysOfWeek) {
                        const period = dayPeriods.find(obj => obj.day === dayOfWeek);
                        if (period != null) {
                            const day = period.day;

                            let timeRange = period.timeRanges[0];
                            
                            let startTime = timeRange.start;
                            let endTime = timeRange.end;

                            if (startTime != null) {

                                const startDate = new Date();
                                const startHour = Number(startTime.substring(0, 2));
                                const startMinute = Number(startTime.substring(startTime.length - 2));
                                startDate.setHours(startHour, startMinute, 0, 0);
                                
                                const endDate = new Date();
                                const endHour = Number(endTime.substring(0, 2));
                                const endMinute = Number(endTime.substring(endTime.length - 2));
                                endDate.setHours(endHour, endMinute, 0, 0);

                                const options = { hour: '2-digit', minute: '2-digit', hour12: true };
                                const startString = startDate.toLocaleString('en-US', options);
                                const endString = endDate.toLocaleString('en-US', options);

                                timeStrings.push(day + ' : ' + startString + ' - ' + endString);
                            }
                
                        } else {
                            timeStrings.push(dayOfWeek + ' : CLOSED');
                        }
                    }
                    hoursLabel.innerText = timeStrings.join('\n');;
                }
            }
            locationParent.appendChild(newLocationCell);
        }
    }

    // MARK: - ZIPCODE MODAL
    $("#zipcodeForm").submit(() => {return false; });

    modalZipcodeButton.addEventListener('click', async () => {
        const zipcodeText = modalZipcodeField.value;
        if (zipcodeText.length == 5) {
            try {
                const address = await validateAddress(zipcodeText);
                sessionStorage.setItem('pickupAddress', JSON.stringify(address));
                zipcodeModal.style.display = 'none';
                setUpView();
            } catch (e) {
                alert('Invalid address: ' + e.message);
            }
        } else {
            alert('zipcode requires 5 digits');
        }
    });

    async function validateAddress(addressText) {
        Radar.initialize(process.env.RADAR_KEY);
        const addressJson =  await Radar.forwardGeocode({ query: addressText });
        const address = addressJson.addresses[0];
        return address;
    }

    function clearCellItems(locationCells) {
        locationCells.forEach((cell, index) => {
            if (index > 0) {
                cell.parentNode.removeChild(cell);
            }
        });
    }

    setUpView();
    
});